import React from 'react';

const OverviewShimmer = () => {
    return (
        <div className='report-shimmer-overview-container'>
            <div className='shimmer-metrics-grid'>
                {Array(4).fill(null).map((_, index) => (
                    <div key={index} className='shimmer-metric-card'>
                        <div className='report-shimmer-card-content'>
                            <div className='report-shimmer-card-header'>
                                <div className='report-shimmer-icon'></div>
                                <div className='shimmer-text-section'>
                                    <div className='report-shimmer-label'></div>
                                    <div className='report-shimmer-value'></div>
                                </div>
                            </div>

                            <div className='shimmer-chart'></div>
                        </div>
                    </div>
                ))}
            </div>

            <style jsx>{`
        .report-shimmer-overview-container {
          border-radius: 4px;
          background-color: #fff;
          display: flex;
          flex-direction: column;
          gap: 20px;
        }

        .report-shimmer-overview-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }


        .shimmer-metrics-grid {
          display: grid;
          gap: 25px;
          grid-template-columns: 1fr;
        }

        @media (min-width: 768px) {
          .shimmer-metrics-grid {
            grid-template-columns: repeat(2, 1fr);
          }
        }

        @media (min-width: 1024px) {
          .shimmer-metrics-grid {
            grid-template-columns: repeat(4, 1fr);
          }
        }

        .shimmer-metric-card {
          border-radius: 4px;
          padding: 12px 16px;
          background: #fff;
          border: 0.5px solid #C3CDDF;
        }

        .report-shimmer-card-content {
          display: flex;
          flex-direction: column;
          gap: 12px;
        }

        .report-shimmer-card-header {
          display: flex;
          align-items: center;
          gap: 12px;
        }

        .report-shimmer-icon {
          width: 40px;
          height: 40px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 50%;
        }

        .shimmer-text-section {
          display: flex;
          flex-direction: column;
          gap: 6px;
          flex: 1;
        }

        .report-shimmer-label {
          width: 80px;
          height: 14px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 2px;
        }

        .report-shimmer-value {
          width: 120px;
          height: 24px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 3px;
        }

        .shimmer-chart {
          width: 100%;
          height: 45px;
          background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
          border-radius: 2px;
          margin-top: 8px;
        }

        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }

        @media (max-width: 768px) {
          .report-shimmer-overview-container {
            padding: 16px;
          }
          
          .report-shimmer-overview-header {
            flex-direction: column;
            gap: 12px;
            align-items: flex-start;
          }
        }
      `}</style>
        </div>
    );
};

export default OverviewShimmer;
